// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"modal_closeButton__GqHWq","closeButtonIcon":"modal_closeButtonIcon__IuA0m"};